import { observer } from "mobx-react";
import React, { useMemo } from "react";

// Define props with proper types
interface HoursProps {
  hours: string[]; // Array of hour labels (e.g., ["08:00", "09:00", ...])
  hoursShown: number; // Number of hours to display
  minuteInterval: any; // Interval between minutes
  hourColumnWidthPx: number; // Width of each hour column in pixels
}

/**
 * Hours component renders table header cells for each hour.
 * It slices the provided hours array based on `hoursShown` and
 * applies consistent column width styling.
 */
const Hours: React.FC<HoursProps> = ({
  hours,
  hoursShown,
  hourColumnWidthPx,
}) => {
  // Memoize displayed hours to avoid recalculating on every render
  const displayedHours = useMemo(() => {
    if (!Array.isArray(hours)) return [];
    return hours.slice(0, hoursShown);
  }, [hours, hoursShown]);

  return (
    <>
      {displayedHours.map((hour, index) => (
        <th
          key={index} // Unique key for each hour
          className="time-column" // CSS class for styling table header
          colSpan={12} // Each hour spans 12 columns (e.g., for 5-minute intervals)
          style={{ width: `${hourColumnWidthPx}px` }} // Inline style for consistent column width
        >
          {hour} {/* Render the hour label */}
        </th>
      ))}
    </>
  );
};

// Wrap with observer to react to MobX state changes
export default observer(Hours);
